import Tooltip from 'components/Tooltip'
import * as React from 'react'
import { SRPRS_ENV } from '../../env'
import Content from '../../pages/shared/content'

interface TextTooltipProps {
  children: JSX.Element
  contentKey: string
  placeholder: string
  direction?: string
}

const TextTooltip: React.FC<TextTooltipProps> = props => {
  return (
    <Tooltip
      direction={props.direction}
      useHover={SRPRS_ENV !== 'editable'}
      content={
        <Content contentKey={props.contentKey}>{props.placeholder}</Content>
      }
    >
      {props.children}
    </Tooltip>
  )
}

export default TextTooltip
